import { HorizBox, Pad, VertBox } from "component/basics";
import { AccordionField, Checkbox, FormField, RadioGroup, RadioOption, SearchField, Toggle } from "component/form";
import { CircleCount, TextField, UtilityText } from "component/text";
import { useState } from "react";
import { View } from "react-native";
import { CLICK, component, demoFile, story, variant } from "system/demo";
import { formatString } from "util/util";
import { t } from "util/stdtypes";

demoFile('component/form', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=1415-5890&t=MC9nppcf9h2iJDKP-1'
});

function FormFieldDemo() {
    const [text, setText] = useState(null);

    return <VertBox wide gap={16}>
        <FormField text='Field label'>
            <TextField multiline placeholder={t('!Text Field')} value={text} onChange={setText} />
        </FormField>
        <FormField text='Required Field' required>
            <TextField multiline placeholder={t('!Text Field')} value={text} setText={setText} />
        </FormField>
        <FormField text='Field with Description' descriptionText='Description appears below' >
            <TextField multiline placeholder={t('!Text Field')} value={text} setText={setText} />
        </FormField>
        <FormField text='Field with Error' errorText='This is an error' >
            <TextField multiline error placeholder={t('!Text Field')} value='Invalid Text' />
        </FormField>
        <FormField text='Small Field'>
            <TextField multiline={false} size='small' placeholder={t('!Text Field')} value={text} setText={setText} />
        </FormField>        
    </VertBox>
}

component('FormField', FormFieldDemo);

function SearchFieldDemo() {
    const [text, setText] = useState(null);
    return <VertBox>
        <SearchField placeholder={t('!Search Field')} value={text} onChangeText={setText} />
        <Pad size={16}/>
        <SearchField size='small' placeholder={t('!Small Search Field')} value={text} onChangeText={setText} />
    </VertBox>
}

component('SearchField', SearchFieldDemo);

component('Search Field', SearchField);

function ToggleDemo() {
    const [switchValue, setSwitchValue] = useState(false);

    return <VertBox gap={16}>
        <Toggle testID='toggle' text='Toggle' value={switchValue} onChange={setSwitchValue} />
        <Toggle emoji='😭' text='Toggle with emoji' value={switchValue} onChange={setSwitchValue} />
        <Toggle emoji='😭' text='Spread Toggle' spread value={switchValue} onChange={setSwitchValue} />
        <Toggle text='This is a toggle with a very long label that needs to be wrapped onto another screen in order to not look bag' value={switchValue} onChange={setSwitchValue} />
    </VertBox>
}

component('Toggle', ToggleDemo, {}, [
    story('Toggle', [
        CLICK('toggle')
    ])
]);

function CheckboxDemo() {
    const [switchValue, setSwitchValue] = useState(false);
    return <VertBox>
        <Checkbox text='Checkbox' value={switchValue} onChange={setSwitchValue} />
        <Checkbox emoji='🔥' text='Checkbox with emoji' value={switchValue} onChange={setSwitchValue} />
    </VertBox>
}

component('Checkbox', CheckboxDemo);

function RadioGroupDemo() {
    const [radioValue, setRadioValue] = useState('cat');
    return <View>
        <RadioGroup value={radioValue} onChange={setRadioValue} >
            <RadioOption text='Cat' radioKey='cat' />
            <RadioOption text='Dog' radioKey='dog' />
            <RadioOption text='Komodo Dragon' radioKey='Komodo Dragon' />                       
        </RadioGroup>  
        <Pad />
        <UtilityText text={formatString('Selected: {value}', {value: radioValue})} />
    </View>
}

component('RadioGroup', RadioGroupDemo, {}, [
    story('Dog', [CLICK('Dog')])
]);

function AccordionFieldDemo() {
    return <View>
        <AccordionField testID='accordion' titleContent={<UtilityText weight='medium' text='Title'/>}>
            <UtilityText text='Content' />
        </AccordionField>
        <AccordionField titleContent={
            <HorizBox center>
                <UtilityText weight='medium' text='With Count'/>
                <Pad size={8} />
                <CircleCount count={3} />
            </HorizBox>                        
        }>
            <UtilityText text='Content' />
        </AccordionField>
    </View>
}

component('AccordionField', AccordionFieldDemo, {}, [
    story('Expand', [CLICK('accordion')])
]);


